export default Vue => {
  Vue.component("v-scroll-to", () => import("./v-scroll-to.vue"));
};
